import { NOTE_FIELDS } from '@/graphql/queries/notes';
import { gql } from '@apollo/client';

export const ADD_NOTE = gql`
    ${NOTE_FIELDS}
    mutation AddNote($note: notes_insert_input!) {
        insert_notes_one(object: $note) {
            ...NoteFields
        }
    }
`;
